import React, { useCallback } from "react";
import classnames from "classnames";
import MediaQuery from "components/MediaQuery";
import DefaultSelect from "components/DefaultSelect";
import { ReactComponent as TriangleArrowDown } from "svg/triangle-arrow-down.svg";
import { SEASON_OPTIONS } from "./rank-filters";

const RankFilters = (props) => {
  const { filters, setFilters, setFiltersChanged } = props;

  const onFilterChange = useCallback(
    (type, option) => {
      setFiltersChanged(true);
      setFilters({ ...filters, [type]: option.value });
    },
    [filters, setFilters],
  );

  const getLabel = (options, value) => {
    const foundOption = options.find((option) => option.value === value);
    return (foundOption && foundOption.label) || "";
  };

  const Filters = ({ isMobile }) => (
    <React.Fragment>
      <DefaultSelect
        title={"Change Season"}
        group={"season"}
        customButton={
          <div className="filter-select_mobile">
            <span>{getLabel(SEASON_OPTIONS, filters.seasonId)}</span>
            <TriangleArrowDown className="dropdown-indicator" />
          </div>
        }
        className={"filter-select"}
        isMobile={isMobile}
        options={SEASON_OPTIONS}
        onChange={(selected) => {
          onFilterChange("seasonId", selected);
        }}
        value={filters.seasonId}
        width={115}
        fontSize={12}
        isSearchable={false}
      />
    </React.Fragment>
  );

  return (
    <div className="match-block_filters">
      <MediaQuery min="TABLET" max="DESKTOP_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters />
          </div>
        )}
      </MediaQuery>
      <MediaQuery min="MOBILE_SMALL" max="MOBILE_LARGE">
        {(mediaQueryClassNames) => (
          <div className={classnames(mediaQueryClassNames, "flex-center")}>
            <Filters isMobile />
          </div>
        )}
      </MediaQuery>
    </div>
  );
};

export default RankFilters;
